module.exports = __webpack_public_path__ + "img/zixun.070b5051.png";